import type { SidebarFontSchemaType } from '@vedalib/editor/lib/brand'
import cn from 'classnames'
import { useCallback } from 'react'

import ButtonStyled from 'components/Editor/EditorElements/courseKit/DropdownMenuCourse/styled/ButtonStyled'
import type { ElementFontCss } from 'services/Branding/types'
import { setSidebar } from 'services/Store/Project/actions'
import { useProjectContext, useProjectDispatch } from 'services/Store/Project/hooks'
import { getSection, isDisabledNavigation } from 'services/Store/Project/selectors'
import { useNavigationAction } from 'services/Store/Project/triggers'
import { testProps } from 'utils/test/qaData'

import * as s from './CourseTitle.module.scss'

interface ICourseTitleProps {
  titleStyles: ElementFontCss<SidebarFontSchemaType>['title']
  projectName?: string
  hidden?: boolean
}

const CourseTitle: React.FC<ICourseTitleProps> = ({ projectName, titleStyles, hidden }) => {
  const cover = useProjectContext(getSection, { cover: true })
  const dispatch = useProjectDispatch()
  const onClose = useCallback(() => dispatch(setSidebar({ open: false })), [dispatch])
  const currentSection = useProjectContext(getSection)
  const onNavigate = useNavigationAction()
  const isDisabledSidebarAndHome = useProjectContext(isDisabledNavigation)
  const disabled = isDisabledSidebarAndHome || !cover
  const goFirstSection = useCallback(() => {
    if (!disabled) {
      onNavigate({ sectionId: cover?.id, currentSection })
      onClose()
    }
  }, [disabled, onNavigate, cover, onClose, currentSection])

  const handleKeyDown = useCallback(
    (e: React.KeyboardEvent<HTMLAnchorElement>) => {
      if (e.key === 'Enter') {
        e.preventDefault()
        goFirstSection()
      }
    },
    [goFirstSection],
  )

  if (!projectName || hidden) {
    return null
  }

  return (
    <ButtonStyled
      as='a'
      className={cn(s.root, disabled && s.active)}
      {...testProps({ el: 'headerTitle', name: projectName })}
      aria-disabled={disabled}
      onClick={goFirstSection}
      onKeyDown={handleKeyDown}
      tabIndex={disabled ? -1 : 0}
    >
      <span className={s.headerTitle} style={titleStyles}>
        {projectName}
      </span>
    </ButtonStyled>
  )
}
export default CourseTitle
